/* eslint-disable no-underscore-dangle */
export default function setCustomValidity(elt, message) {
  return (
    elt._reactInternalFiber.child.stateNode.setCustomValidity &&
    elt._reactInternalFiber.child.stateNode.setCustomValidity(message)
  );
}
